<img [src]="data.url" class="img-responsive" />